/** 仓库和库存路由 */
export default {
    name: 'warehouse',
    path: 'warehouse',
    meta: { title: '仓库和库存管理' },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'warehouse-manage',
            path: 'manage',
            meta: { title: '仓库管理' },
            component: () => import('@/pages/warehouse/manage.vue')
        },
        {
            name: 'warehouse-operation',
            path: 'operation',
            meta: { title: '入库和调拨操作' },
            component: () => import('@/pages/warehouse/operation.vue')
        },
        {
            name: 'warehouse-parent',
            path: 'parent',
            meta: { title: '总部库存明细' },
            component: () => import('@/pages/warehouse/parent.vue')
        },
        {
            name: 'warehouse-distributor',
            path: 'distributor',
            meta: { title: '代理商库存明细' },
            component: () => import('@/pages/warehouse/distributor.vue')
        },
        {
            name: 'warehouse-shop',
            path: 'shop',
            meta: { title: '门店库存明细' },
            component: () => import('@/pages/warehouse/shop.vue')
        },
        {
            name: 'warehouse-analysis',
            path: 'analysis',
            meta: { title: '库存统计分析' },
            component: () => import('@/pages/warehouse/analysis.vue')
        }
    ]
}
